import { render, staticRenderFns } from "./SetUpDone.vue?vue&type=template&id=82e038f0&scoped=true"
import script from "./SetUpDone.vue?vue&type=script&lang=js"
export * from "./SetUpDone.vue?vue&type=script&lang=js"
import style0 from "./SetUpDone.vue?vue&type=style&index=0&id=82e038f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e038f0",
  null
  
)

export default component.exports